// extracted by mini-css-extract-plugin
export default {"faqHeading":"Faq_faqHeading__LNESS","faqBody":"Faq_faqBody__iG6mq","faqItem":"Faq_faqItem__lCdMe","faqContainer":"Faq_faqContainer__KZ7e3"};